const STATUS_TYPE = {
  0: "Kode etik dan/atau berkas belum diisi",
  2: "Maju sidang belum disetujui",
  3: "Jadwal sidang belum ditentukan",
  4: "Menunggu sidang",
  5: "Proses evaluasi",
  7: "Menunggu berkas akhir",
  8: "Selesai MK spesial",
  "01": "Menunggu peer review",
};

const KODE_STATUS_TYPE = {
  KODE_ETIK_DAN_ATAU_BERKAS_BELUM_DIISI: "0",
  MAJU_SIDANG_BELUM_DISETUJUI: "2",
  JADWAL_SIDANG_BELUM_DITENTUKAN: "3",
  MENUNGGU_SIDANG: "4",
  PROSES_EVALUASI: "5",
  MENUNGGU_BERKAS_AKHIR: "7",
  SELESAI_MK_SPESIAL: "8",
  MENUNGGU_PEER_REVIEW: "01",
};

const STATUS_SENTENCES = {
  "Menunggu kode etik dan/atau berkas": "Menunggu kode etik dan/atau berkas",
  "Menunggu persetujuan maju sidang": "Menunggu persetujuan maju sidang",
  "Menunggu penjadwalan sidang": "Menunggu penjadwalan sidang",
  "Menunggu sidang": "Menunggu sidang",
  "Menunggu penilaian dan/atau revisi":
    "Menunggu penilaian dan/atau revisi",
  "Menunggu berkas akhir": "Menunggu berkas akhir",
  Selesai: "Selesai",
  "Menunggu peer review": "Menunggu peer review",
};

const STATUS_TYPE_CHART_MAPPINGS = {
  status_etik_dan_berkas: STATUS_SENTENCES["Menunggu kode etik dan/atau berkas"],
  status_persetujuan_sidang: STATUS_SENTENCES["Menunggu persetujuan maju sidang"],
  status_peer_review: STATUS_SENTENCES["Menunggu peer review"],
  status_penjadwalan_sidang: STATUS_SENTENCES["Menunggu penjadwalan sidang"],
  status_menunggu_sidang: STATUS_SENTENCES["Menunggu sidang"],
  status_evaluasi: STATUS_SENTENCES["Menunggu penilaian dan/atau revisi"],
  status_berkas_akhir: STATUS_SENTENCES["Menunggu berkas akhir"],
  status_selesai: STATUS_SENTENCES.Selesai 
}

export { 
  STATUS_TYPE, 
  KODE_STATUS_TYPE, 
  STATUS_SENTENCES,
  STATUS_TYPE_CHART_MAPPINGS
};
